"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEESABLE_PRIVACY_URL = exports.FEESABLE_TERMS_URL = exports.FEESABLE_URL = void 0;
exports.FEESABLE_URL = 'https://feesable.com.au';
exports.FEESABLE_TERMS_URL = 'https://feesable.com.au/terms-of-use/';
exports.FEESABLE_PRIVACY_URL = 'https://feesable.com.au/privacy/';
